import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { IssueTrackingModule } from './issue-tracking/issue-tracking.module';

@NgModule({
  imports: [CommonModule, HomeRoutingModule, IssueTrackingModule],
  declarations: [HomeComponent],
})
export class HomeModule {}
